export const MODULE_NAME = 'eventsAirSync';
